var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.147,
    height: 44.362,
    viewBox: "0 0 84.147 44.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_92_1",
    "data-name": "Component 92 \\u2013 1",
    transform: "translate(0 0.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M78.693,24.543A2.727,2.727,0,1,1,81.42,27.27,2.727,2.727,0,0,1,78.693,24.543ZM54.54,27.27a2.741,2.741,0,0,1-.584-.063,2.744,2.744,0,0,1-.584.063H17.92a2.727,2.727,0,0,1,0-5.454H2.727a2.727,2.727,0,1,1,0-5.454H18.31a2.727,2.727,0,0,0,0-5.454H8.57a2.727,2.727,0,0,1,0-5.454H24.153a2.727,2.727,0,0,1,0-5.454H46.359a2.727,2.727,0,0,1,0,5.454H71.291a2.727,2.727,0,1,1,0,5.454h8.571a2.727,2.727,0,0,1,0,5.454h-7.4a2.727,2.727,0,1,0,0,5.454H74.8a2.727,2.727,0,0,1,0,5.454Z",
    transform: "translate(0 8.96)",
    fill: "rgba(250,168,79,0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photo2",
    transform: "translate(19.089 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M30.733,0h1.6a1.558,1.558,0,0,1,1.558,1.558V32.724a1.558,1.558,0,0,1-1.558,1.558H1.558A1.558,1.558,0,0,1,0,32.724V30.046",
    transform: "translate(38.334 33.949) rotate(172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    d: "M6.943,34.565l-1.44.2a1.41,1.41,0,0,1-1.6-1.2L.014,5.548a1.42,1.42,0,0,1,1.207-1.6L28.894.014a1.41,1.41,0,0,1,1.6,1.2l.335,2.408,3.586,25.945a1.573,1.573,0,0,1-1.328,1.779l-.027,0Z",
    transform: "translate(1.941 1.943)",
    fill: "rgba(250,168,79,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    d: "M30.733,0h1.6a1.558,1.558,0,0,1,1.558,1.558V32.724a1.558,1.558,0,0,1-1.558,1.558H1.558A1.558,1.558,0,0,1,0,32.724V30.046",
    transform: "translate(38.334 33.949) rotate(172)",
    fill: "none",
    stroke: "#f8a758",
    strokeLinecap: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M.25,0,.445,1.216",
    transform: "translate(34.227 5.992)",
    fill: "none",
    stroke: "#f8a758",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Photo1",
    transform: "translate(28.36 5.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 3.583, 0)",
    fill: "#fff",
    stroke: "#f8a758",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.892,
    height: 34.282,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 32.592,
    height: 32.982,
    rx: 3.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 26.88,
    height: 22.985,
    rx: 3,
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 6.704, 3.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1,6.155,4.53,3.2a1.558,1.558,0,0,1,2.026.02l3.094,2.7a.39.39,0,0,0,.532-.018L15.619.457A1.558,1.558,0,0,1,17.934.58l4.5,5.575.653.868.065,3.176a.39.39,0,0,1-.392.4L.429,10.464a.39.39,0,0,1-.387-.385L0,6.872Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 7.414, 14.616)",
    fill: "rgba(248,167,88,0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 6.704, 3.854)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0H23.88a3,3,0,0,1,3,3V19.985a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.000001907348633 1.299997329711914 C 2.0626220703125 1.299997329711914 1.30000114440918 2.062618255615234 1.30000114440918 2.999998092651367 L 1.30000114440918 19.98461723327637 C 1.30000114440918 20.9219970703125 2.0626220703125 21.68461799621582 3.000001907348633 21.68461799621582 L 23.88022041320801 21.68461799621582 C 24.81760025024414 21.68461799621582 25.58022117614746 20.9219970703125 25.58022117614746 19.98461723327637 L 25.58022117614746 2.999998092651367 C 25.58022117614746 2.062618255615234 24.81760025024414 1.299997329711914 23.88022041320801 1.299997329711914 L 3.000001907348633 1.299997329711914 M 3.000001907348633 -1.9073486328125e-06 L 23.88022041320801 -1.9073486328125e-06 C 25.53708076477051 -1.9073486328125e-06 26.88022041320801 1.343147277832031 26.88022041320801 2.999998092651367 L 26.88022041320801 19.98461723327637 C 26.88022041320801 21.6414680480957 25.53708076477051 22.98461723327637 23.88022041320801 22.98461723327637 L 3.000001907348633 22.98461723327637 C 1.343141555786133 22.98461723327637 1.9073486328125e-06 21.6414680480957 1.9073486328125e-06 19.98461723327637 L 1.9073486328125e-06 2.999998092651367 C 1.9073486328125e-06 1.343147277832031 1.343141555786133 -1.9073486328125e-06 3.000001907348633 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#f8a758"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.337,
    cy: 2.337,
    rx: 2.337,
    ry: 2.337,
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 10.477, 8.951)",
    fill: "rgba(248,167,88,0.15)",
    stroke: "#f8a758",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M0,6.836,4.243,3.2a1.558,1.558,0,0,1,2.026.02l3.094,2.7A.39.39,0,0,0,9.895,5.9L15.332.457A1.558,1.558,0,0,1,17.647.58l5,6.351",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 7.7, 14.646)",
    fill: "none",
    stroke: "#f8a758",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCard);
export default __webpack_public_path__ + "static/media/upload-card.f3bf59b91d386559e3880aca08eac427.svg";
export { ForwardRef as ReactComponent };